import React from 'react'
import _ from 'underscore'
import { Label } from '@/components/ui/label'
import Select from '../../select'

class EditCommissionManager extends React.Component {

  onChange = (value) => {
    this.props.onChange(value)
  }

  render() {
    const claim_managers_options = _.map(this.props.claim_managers, function(claim_manager) {
      return [claim_manager.id, claim_manager.name]
    })

    return (
      <div className="flex items-center gap-4">
        <Label className="shrink-0">Sales Commission:</Label>
        <div className="flex-1">
          <Select options={claim_managers_options} value={this.props.commission_manager_id} onChange={this.onChange}/>
        </div>
      </div>
    )
  }
}

export default EditCommissionManager
